import React, { useRef, useEffect, useState, useContext, useMemo } from "react";
import { Carousel, Row, Col, Button } from "antd";
// import { ParticipantType } from "@/pages/Meeting/data";
import VideoCard from "../VideoCard";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";
import { ParticipantType } from "@/types";
import Whiteboard from "../../Whiteboard";

const ThumbnailLayout = () => {
  const { displayParticipants: participants, service } = useContext(MeetingContext);
  const carousel = useRef<any>();
  const navbar = useRef<HTMLDivElement>();
  const [size, setSize] = useState(1);
  const [page, setPage] = useState(0);

  const NAV_HEIGHT = 220;
  const NAV_MARGIN = 100;

  const mainParticipant =
    participants.find((d) => d.pinned) ||
    participants.find((d) => d.share) ||
    participants.find((d) => d.active) ||
    participants[1] ||
    participants[0];

  const listPeers = participants.filter(
    (peer: ParticipantType) => !peer.share && !peer.active
  );

  // useEffect(() => {
  //   const width = navbar.current.clientWidth - NAV_MARGIN;
  //   setSize(Math.floor(width / NAV_HEIGHT));
  // }, []);

  // useEffect(() => {
  //   if (size > 1) {
  //     console.log("[ThumbnailLayout] muteVideo");
  //     muteVideo(page, size, participants, mainParticipant.peerId);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [page, size, participants.length]);

  useEffect(() => {
    console.log(`[ThumbnailLayout] useEffect`);
    const width = navbar.current.clientWidth - NAV_MARGIN;
    let sideSize = Math.floor(width / NAV_HEIGHT);
    setSize(sideSize);
    //subscribe video or unsubscribe video
    //mainParticipant or listPeers may be me
    console.log(`[ThumbnailLayout] useEffect mainParticipant=${mainParticipant.peerId} page=${page} size=${sideSize} listPeers.length=${listPeers.length}`);
    (async function initFunction() {
      console.log(`[ThumbnailLayout] useEffect participants length=${participants.length}`);
      if(mainParticipant.local){

      }else{
        if (!mainParticipant.videoTrack && !mainParticipant.bInActivePage) {
          await service.setParticipantInActivePage(mainParticipant.peerId, true);
          //await window.roomClient.subscribeVideo(mainParticipant.peerId);
        }
      }
      for (let i = 1; i < listPeers.length; i++) {
        const listPeer = listPeers[i];
        
        if ((i >= page * sideSize && i < (page + 1) * sideSize)){
          if (listPeer.videoTrack || listPeer.local || listPeer.bInActivePage) {
            continue;
          }
          console.log(`[SideLayout] useEffect subscribeVideo i=${i}`)
          await service.setParticipantInActivePage(listPeer.peerId, true);
          //await window.roomClient.subscribeVideo(listPeer.peerId);
        }else{
          if (!listPeer.bInActivePage) {
            continue;
          }
          console.log(`[SideLayout] useEffect unsubscribeVideo i=${i}`)
          await service.setParticipantInActivePage(listPeer.peerId, false);
          //await window.roomClient.unsubscribeVideo(listPeer.peerId);
        }
      }
    })();

  }, [mainParticipant, page, listPeers.length]);

  const next = () => {
    carousel.current.next();
  };

  const prev = () => {
    carousel.current.prev();
  };

  const pagination = useMemo(() => {
    const res = [];
    for (let i = 1; i <= Math.ceil(listPeers.length / size); i++) {
      res.push(listPeers.slice((i - 1) * size, i * size));
    }
    return res;
  }, [size, listPeers]);

  // const operateWhiteBoardShow = (f: boolean) => {
  //   service.sendCustomCmdMsg({
  //     cmdId: f ? 20 : 29,
  //     data: {},
  //   });
  //   board.setBoardShow(f);
  // };

  return (
    <div className="thumbnail_container">
      <div className={style.navbar} ref={navbar}>
        <Carousel ref={carousel} dots={false} afterChange={setPage}>
          {pagination.map((peers, i: number) => (
            <div key={i}>
              <Row gutter={8} justify="center">
                {peers.map((d) => (
                  <Col key={d.peerId} flex={`0 0 ${NAV_HEIGHT}px`}>
                    <VideoCard participant={d} compact />
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </Carousel>
        <Button
          className={style.prev}
          icon={<LeftOutlined />}
          shape="circle"
          disabled={page <= 0}
          onClick={prev}
        />
        <Button
          className={style.next}
          icon={<RightOutlined />}
          shape="circle"
          disabled={page >= participants.length / size - 1}
          onClick={next}
        />
      </div>
      <div className={`${style.main} andddd`}>
        {/* {board.boardShow && (
          <div className={style.wb}>
            <Whiteboard leave={() => operateWhiteBoardShow(false)} />
          </div>
        )} */}

        <VideoCard participant={mainParticipant} cover />
      </div>
    </div>
  );
};

export default ThumbnailLayout;
